import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ArrowRight = ({ className }) => {
  return (
    <svg
      viewBox='0 0 11 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-arrow-right', { [className]: className })}
    >
      <path
        d='M10.3536 7.35355C10.5488 7.15829 10.5488 6.84171 10.3536 6.64645L7.17157 3.46447C6.97631 3.2692 6.65973 3.2692 6.46447 3.46447C6.2692 3.65973 6.2692 3.97631 6.46447 4.17157L9.29289 7L6.46447 9.82843C6.2692 10.0237 6.2692 10.3403 6.46447 10.5355C6.65973 10.7308 6.97631 10.7308 7.17157 10.5355L10.3536 7.35355ZM0 7.5H10V6.5H0V7.5Z'
        fill='currentColor'
      />
    </svg>
  );
};

ArrowRight.propTypes = {
  className: PropTypes.string,
};

export default ArrowRight;
